import {
  ActionType,
  BlockUser,
  CheckAccessibilityViaForward,
  GetBlockedUsers,
  GetUserPolicy,
  PolicyType,
  PrivacyType,
  RemoveUserPolicy,
  reqBlockUser,
  reqCheckAccessibilityViaForward,
  reqGetBlockedUsers,
  reqGetUserPolicy,
  reqRemoveUserPolicy,
  reqSetPrivacyPolicy,
  reqSetUserPolicy,
  reqUnBlockUser,
  SetPrivacyPolicy,
  SetUserPolicy,
  UnBlockUser,
  UserPolicy,
} from '@weblite/ts-action/user-policy'
import {
  showUserBannedSnackbar,
  showUserUnbannedSnackbar,
} from '$comp/snackbars'
import { usersStorage } from '$logic/users/storage'
import { updateCachedUserPermissionsInPv } from '$logic/user-permissions'
import { request } from '$setup/ws'
import { isClientUserSupport } from '$logic/client-user'
import { SHOW_USER_INFO_TO_SUPPORT } from '$func/environmentInfo'

// TODO cache
export async function getUserPolicy(
  privacyType: PrivacyType,
): Promise<UserPolicy> {
  const res = await request<GetUserPolicy>(reqGetUserPolicy({ privacyType }))
  if (res.error) return null
  return res.payload
}

// TODO: impl a single `setUserPolicy` which is the opposite of `getUserPolicy` and replaces the 3 below functions
export async function setPrivacyPolicy(
  privacyType: PrivacyType,
  policy: PolicyType,
): Promise<boolean> {
  const res = await request<SetPrivacyPolicy>(
    reqSetPrivacyPolicy({ privacyType, policy }),
  )
  if (res.error) return false
  return true
}

// NOTE: grabbed todo from doc "rename e.g. setUserExceptionPolicy"
export async function setUserPolicy(
  privacyType: PrivacyType,
  userIds: string[],
  action: ActionType,
): Promise<boolean> {
  const res = await request<SetUserPolicy>(
    reqSetUserPolicy({ privacyType, userIds, action }),
  )
  if (res.error) return false
  return true
}

// NOTE: grabbed todo from doc "rename e.g. removeUserExceptionPolicy"
export async function removeUserPolicy(
  userIds: string[],
  privacyType: PrivacyType,
): Promise<boolean> {
  const res = await request<RemoveUserPolicy>(
    reqRemoveUserPolicy({ privacyType, userIds }),
  )
  if (res.error) return false
  return true
}

export async function blockUser(userId: string): Promise<boolean> {
  const res = await request<BlockUser>(reqBlockUser({ userId }))
  if (res.error) return false
  showUserBannedSnackbar()

  await usersStorage.set(userId, { isBlocked: true })
  await updateCachedUserPermissionsInPv(userId)

  return true
}

export async function unBlockUser(userId: string): Promise<boolean> {
  const res = await request<UnBlockUser>(reqUnBlockUser({ userId }))
  if (res.error) return false
  showUserUnbannedSnackbar()

  await usersStorage.set(userId, { isBlocked: undefined })
  await updateCachedUserPermissionsInPv(userId)

  return true
}

// NOTE: return { userIds: string[] } instead of string[]
export async function getBlockedUsers(): Promise<{ userIds: string[] }> {
  // TODO: don't pass payload
  const res = await request<GetBlockedUsers>(reqGetBlockedUsers({}))
  if (res.error) return null
  return res.payload
}

export async function checkUserAccessibilityViaForwardWithUserId(
  userId: string,
) {
  if (isClientUserSupport() && SHOW_USER_INFO_TO_SUPPORT) return true

  const res = await request<CheckAccessibilityViaForward>(
    reqCheckAccessibilityViaForward({ userId }),
  )

  return res.payload?.accessible
}
